import angular from 'angular';
import contactListComponent from './contact-list.component';

export default angular.module('components.app.adverseEvent.contactList', [])
  .component('contactList', contactListComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/adverse-event/contact-list/contact-list.module.js